import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { Icon } from './Icon';
import s from './Button.module.css';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'default' | 'primary' | 'text' | 'ghost';
  danger?: boolean;
  size?: 'sm' | 'md' | 'lg';
  icon?: string;
  block?: boolean;
  /** 置灰时必须写原因（文档 23 §11：按钮置灰只因权限或流程阻塞，原因要看得见） */
  disabledReason?: string;
  children?: ReactNode;
};

export function Button({ variant = 'default', danger, size = 'md', icon, block, disabledReason, className, children, ...rest }: Props) {
  const cls = [s.btn, s[variant], s[size], danger && s.danger, block && s.block, className].filter(Boolean).join(' ');
  return (
    <button type="button" className={cls} title={rest.disabled ? disabledReason : rest.title} {...rest}>
      {icon && <Icon name={icon} size={size === 'lg' ? 18 : 16} />}
      {children}
    </button>
  );
}

export function IconButton({ name, label, badge, onClick }: { name: string; label: string; badge?: ReactNode; onClick?: () => void }) {
  return (
    <button type="button" className={s.ib} aria-label={label} title={label} onClick={onClick}>
      <Icon name={name} size={20} />
      {badge != null && <span className={s.ibBadge}>{badge}</span>}
    </button>
  );
}
